/** OS Optimal Sailing (formerly EV) */
import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatMass } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  os_threshold_kg: 10000,
  total_fuel_mgo_corrected_kg: 9000,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "tonnes",
  metadata = defaultMetadata,
  industry,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  let threshold = metadata["os_threshold_kg"];
  let actual = metadata["total_fuel_mgo_corrected_kg"];
  if (!threshold || !actual) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  threshold = Number(threshold);
  actual = Number(actual);

  const data = [
    {
      name: "Actual total fuel consumption",
      mobileName: "Actual",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = 0.2 * actual;
  const domainMax =
    actual < threshold
      ? Math.ceil(threshold + margin)
      : Math.ceil(Math.ceil((actual + margin) / 100) * 100);
  const domain = [domainMin, domainMax];

  const mobileMargin = 0.05 * actual;
  const mobileDomainMax =
    actual < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil((actual + margin) / 10) * 10;
  const mobileDomain = [domainMin, mobileDomainMax];
  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Ship-specific threshold${
        !isExample
          ? ` (${formatMass(industry, threshold, 0, { boundaryValues: [0, actual] }).formattedValue})`
          : ""
      }`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      unitOfMeasure={unit}
      axisLabel={`Total fuel consumption`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatMass(industry, value, 0, { boundaryValues: [0, threshold] }).formattedValue}`
      }
      isExample={isExample}
    />
  );
}
